import React, { useEffect } from 'react';
import { GLOBAL_OPTIONS_KEY, DEFAULT_VOLUME, APPS, PT } from './const';
import { CM, MS, MT, NM, RE, SM, TA, TM, TT, PN } from './const';
import { useDispatch, useSelector } from 'react-redux';
import { SET_GLOBAL_OPTIONS, SELECT_APP, SET_BEEN_HOME, SET_SINGLE_APP } from './REDUX/actions';
import Triangula from '../TA/COMPONENTS/Triangula';
import MindShapes from '../MS/COMPONENTS/MindShapes';
import TurboTiles from '../TT/COMPONENTS/TurboTiles';
import MemoryTwist from '../MT/COMPONENTS/MemoryTwist';
import Triomino from '../TM/COMPONENTS/Triomino';
import Symbolica from '../SM/COMPONENTS/Symbolica';
import Numerica from '../NM/COMPONENTS/Numerica';
import RokuEn from '../RE/COMPONENTS/RokuEn';
import ColorMatch from '../CM/COMPONENTS/ColorMatch';
import Pairanoia from '../PN/COMPONENTS/Pairanoia';
import Permutile from '../PT/COMPONENTS/Permutile';
import HomePage from './HomePage';
import { getAppInfo } from './info';
import _ from 'lodash';
import { useRoutes, usePath, navigate } from 'hookrouter';
import { SINGLE_APP, USE_ROUTER } from './config';
import { dbget } from './utils';

const routes = {
  '/': () => <HomePage />,
  '/ta': () => <Triangula />,
  '/triangula': () => <Triangula />,
  '/ms': () => <MindShapes />,
  '/mindshapes': () => <MindShapes />,
  '/tt': () => <TurboTiles />,
  '/turbotiles': () => <TurboTiles />,
  '/mt': () => <MemoryTwist />,
  '/memorytwist': () => <MemoryTwist />,
  '/tm': () => <Triomino />,
  '/triomino': () => <Triomino />,
  '/sm': () => <Symbolica />,
  '/symbolica': () => <Symbolica />,
  '/nm': () => <Numerica />,
  '/numerica': () => <Numerica />,
  '/re': () => <RokuEn />,
  '/rokuen': () => <RokuEn />,
  '/cm': () => <ColorMatch />,
  '/colormatch': () => <ColorMatch />,
  '/pn': () => <Pairanoia />,
  '/pairanoia': () => <Pairanoia />,
  '/pt': () => <Permutile />,
  '/permutile': () => <Permutile />,
};

const Home = () => {
  const dispatch = useDispatch();
  const { common } = useSelector(state => state);

  useEffect(() => {
    const callback = options => {
      if (!options) {
        options = {};
      }

      if (options.volume === undefined) {
        options.volume = DEFAULT_VOLUME;
      }

      dispatch({ type: SET_GLOBAL_OPTIONS, options });
    };

    dbget(GLOBAL_OPTIONS_KEY, callback, err => alert(err));
  }, [dispatch]);

  const route = useRoutes(routes);
  let path = usePath(false);

  if (USE_ROUTER) {
    if (!route) {
      dispatch({ type: SET_BEEN_HOME });
      navigate('/', true);
      return null;
    }

    path = path.substr(1).toUpperCase();

    if (_.isEmpty(path)) {
      if (!common.beenHome) {
        dispatch({ type: SET_BEEN_HOME });
      }
    } else {
      _.each(APPS, app => {
        if (app !== common.app && (app === path || getAppInfo(app, true).name === path)) {
          dispatch({ type: SELECT_APP, app });
          return false;
        }
      });
    }

    return route;
  } else {
    let app = common.app;

    if (!app) {
      if (SINGLE_APP) {
        app = SINGLE_APP;
        dispatch({ type: SET_SINGLE_APP });
        dispatch({ type: SELECT_APP, app });
      } else {
        return <HomePage />;
      }
    }

    switch (app) {
      case TA:
        return <Triangula />;
      case MS:
        return <MindShapes />;
      case TT:
        return <TurboTiles />;
      case MT:
        return <MemoryTwist />;
      case TM:
        return <Triomino />;
      case SM:
        return <Symbolica />;
      case NM:
        return <Numerica />;
      case RE:
        return <RokuEn />;
      case CM:
        return <ColorMatch />;
      case PN:
        return <Pairanoia />;
      case PT:
        return <Permutile />;
      default:
        return <div className="root-message">SINGLE APP!</div>;
    }
  }
};

export default Home;
